<template>
  <div class="home-page">
    <!-- Banner Section -->
    <section class="banner__one">
      <div class="pattern-layer d-none d-lg-block">
        <ParallaxComponent
          :offset="0"
          :speed="2.8"
          :bgImage="shap1"
          :strength="100"
          className="banner__icon pattern-1 position-absolute"
        />
      </div>
      <div class="banner__data position-relative">
        <div
          class="banner__bg d-none d-lg-block"
          :style="{ backgroundImage: `url(${bannerBg})` }"
        ></div>
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <div class="banner__left">
                <div class="sub__title">
                  <h4>Software Innovation</h4>
                </div>
                <div class="banner__title">
                  <h1>
                    Building the Future with <span>Software Innovation</span>
                  </h1>
                </div>
                <div class="text">
                  <p>
                    At Sogdo, we develop world-class software products powered
                    by the latest tech stacks — fast, scalable, and smart.
                  </p>
                </div>
                <div class="btn-box">
                  <router-link to="/home-services" class="theme-btn theme-btn-one">
                    <i class="icon-02"></i> Explore Services
                  </router-link>
                  <router-link to="/home-contact" class="theme-btn outline-btn">
                    <i class="icon-02"></i> Talk to Experts
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-lg-2"></div>
            <div class="col-lg-4 col-md-12">
              <div class="banner__right position-relative">
                <div class="image__one">
                  <figure
                    class="image-box wow slideInUp animated"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <img :src="banner1" alt="" />
                  </figure>
                </div>
                <div class="icon__image__banner">
                  <div class="circle-main">
                    <div class="circle">
                      <img :src="c2" class="" alt="" />
                      <div class="round-text">
                        <div class="text_1">
                          <p class="text_2">
                            years experience years experience
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Our Offerings Overview Section -->
    <HomeItsOurOfferingsComp :content="ourOfferingsContent" />

    <!-- Industries We Serve Section -->
    <HomeItsIndustriesComp :content="industriesContent" />

    <!-- Why Sogdo Section -->
    <HomeItsWhySogdoComp :content="whySogdoContent" />

    <!-- Testimonials Section -->
    <HomeItsTestimonialComp :content="testimonialsContent" />

    <!-- Who We Are Section -->
    <HomeItsWhoWeAreComp :content="whoWeAreContent" />

    <!-- About Us Section -->
    <HomeItsAboutUsComp :content="aboutUsContent" />

    <!-- Case Studies Section -->
    <HomeItsCaseStudiesComp :content="caseStudiesContent" />

    <!-- Contact Section -->
    <HomeItsContactComp :content="contactContent" />
  </div>
</template>

<script>
import { onMounted } from "vue";
import WOW from "wowjs";
import ParallaxComponent from "@/components/ParallaxComponent.vue";
import HomeItsAboutUsComp from "@/components/HomeItsAboutUsComp.vue";
import HomeItsOurOfferingsComp from "@/components/HomeItsOurOfferingsComp.vue";
import HomeItsIndustriesComp from "@/components/HomeItsIndustriesComp.vue";
import HomeItsCaseStudiesComp from "@/components/HomeItsCaseStudiesComp.vue";
import HomeItsWhySogdoComp from "@/components/HomeItsWhySogdoComp.vue";
import HomeItsContactComp from "@/components/HomeItsContactComp.vue";
import HomeItsWhoWeAreComp from "@/components/HomeItsWhoWeAreComp.vue";
import HomeItsTestimonialComp from "@/components/HomeItsTestimonialComp.vue";

// Import images
import shap1 from "@/assets/images/banner/bannershap1.png";
import bannerBg from "@/assets/images/banner/banner1.png";
import banner1 from "@/assets/images/banner/banner-01.png";
import c2 from "@/assets/logo.png";

// Import case study images
import caseStudyImage1 from "@/assets/images/resource/service-details.jpg";
import caseStudyImage2 from "@/assets/images/resource/portfolio-01.jpg";
import caseStudyImage3 from "@/assets/images/resource/portfolio-02.jpg";

export default {
  name: "HomePage",
  components: {
    ParallaxComponent,
    HomeItsAboutUsComp,
    HomeItsOurOfferingsComp,
    HomeItsIndustriesComp,
    HomeItsCaseStudiesComp,
    HomeItsWhySogdoComp,
    HomeItsContactComp,
    HomeItsWhoWeAreComp,
    HomeItsTestimonialComp,
  },
  setup() {
    onMounted(() => {
      // Initialize WOW.js
      new WOW.WOW({
        mobile: false,
      }).init();

      // Initialize circular text animation
      setTimeout(() => {
        const text_2 = document.querySelector(".text_2");
        if (text_2) {
          text_2.innerHTML = text_2.innerText
            .split("")
            .map(
              (char, i) =>
                `<span style="position: absolute; left: 50%; transform-origin: 0 100px; transform:rotate(${
                  i * 10.3
                }deg)">${char}</span>`
            )
            .join("");
        }
      }, 100);

      // Initialize count-up animation
      const initCountUp = () => {
        const statNumbers = document.querySelectorAll(".stat-number");

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const target = entry.target;
                const count = parseInt(target.getAttribute("data-count"));
                const duration = 2000; // 2 seconds
                const increment = count / (duration / 16); // 60fps
                let current = 0;

                const timer = setInterval(() => {
                  current += increment;
                  if (current >= count) {
                    current = count;
                    clearInterval(timer);
                  }
                  target.textContent = Math.floor(current);
                }, 16);

                observer.unobserve(target);
              }
            });
          },
          { threshold: 0.5 }
        );

        statNumbers.forEach((number) => {
          observer.observe(number);
        });
      };

      // Initialize count-up after a short delay
      setTimeout(initCountUp, 500);

      // Initialize Case Studies Swiper
      initCaseStudiesSwiper();
    });

    // Initialize Case Studies Swiper
    const initCaseStudiesSwiper = () => {
      setTimeout(() => {
        if (window.Swiper) {
          new window.Swiper(".case-studies-swiper", {
            loop: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            on: {
              slideChange: function () {
                // Reset and restart count-up animation on slide change
                const statNumbers = document.querySelectorAll(
                  ".swiper-slide-active .stat-number"
                );
                statNumbers.forEach((number) => {
                  const count = parseInt(number.getAttribute("data-count"));
                  const duration = 2000;
                  const increment = count / (duration / 16);
                  let current = 0;

                  const timer = setInterval(() => {
                    current += increment;
                    if (current >= count) {
                      current = count;
                      clearInterval(timer);
                    }
                    number.textContent = Math.floor(current);
                  }, 16);
                });
              },
            },
          });
        }
      }, 1000);
    };

    // About Us content object
    const aboutUsContent = {
      sectionLabel: "About Us",
      mainTitle: "Who we are",
      description:
        "Sogdo is a group of passionate technology professionals, delivering customer-centric solutions for over two decades. We believe in achieving organizational scalability with innovation, workflow optimization, and digital transformation. Technology at our core and customers in our hearts.",
      ctaText: "Learn More",
      ctaLink: "/home-about",
      stats: [
        {
          number: 15,
          label: "YEARS OF EXPERIENCE",
        },
        {
          number: 500,
          label: "GLOBAL WORKFORCE",
        },
        {
          number: 1000,
          label: "PROJECT DELIVERED",
        },
        {
          number: 25,
          label: "INNOVATION AWARDS",
        },
      ],
    };

    // Our Offerings content object
    const ourOfferingsContent = {
      sectionLabel: "What We Do",
      mainTitle: "From Idea to Product –",
      mainTitleHighlight: "We Build It All",
      description:
        "We develop world-class software products powered by the latest tech stacks — fast, scalable, and smart solutions for every industry.",
      blocks: [
        {
          blockClass: "services-block",
          icon: "icon-01",
          title: "Services",
          description:
            "Professional software development and technology services tailored to your business needs.",
          features: [
            "🔧 Software Product Development",
            "🧠 AI & Machine Learning Solutions",
            "📲 Mobile & Web App Development",
            "☁️ Cloud & DevOps Integration",
            "🛒 E-commerce & ERP Solutions",
            "🔐 Cybersecurity Tools",
          ],
          ctaText: "Explore Services",
          ctaLink: "/home-services",
          shape1: "/shapes/shape-01.png",
          shape2: "/shapes/shape-11.png",
        },
        {
          blockClass: "synergy-block",
          icon: "icon-03",
          title: "Synergy Products",
          description:
            "Innovative products and solutions that combine cutting-edge technology with practical applications.",
          features: [
            "AR/VR Solutions",
            "AI-Powered Tools",
            "Mobile Applications",
            "Enterprise Software",
          ],
          ctaText: "View Products",
          ctaLink: "/home-synergy",
          shape1: "/shapes/shape-02.png",
          shape2: "/shapes/shape-12.png",
        },
        {
          blockClass: "research-block",
          icon: "icon-04",
          title: "Research",
          description:
            "Pioneering research initiatives that push the boundaries of technology and innovation.",
          features: [
            "Emerging Technologies",
            "Industry Analysis",
            "Innovation Labs",
            "Academic Partnerships",
          ],
          ctaText: "Learn More",
          ctaLink: "/home-research",
          shape1: "/shapes/shape-04.png",
          shape2: "/shapes/shape-10.png",
        },
      ],
    };

    // Industries content object
    const industriesContent = {
      sectionLabel: "Industries We Serve",
      mainTitle: "Transforming Industries with",
      mainTitleHighlight: "Software Innovation",
      description:
        "We serve diverse industries with specialized software solutions tailored to their unique challenges and requirements.",
      industries: [
        {
          icon: "🏥",
          name: "Healthcare",
        },
        {
          icon: "💰",
          name: "Fintech",
        },
        {
          icon: "🎓",
          name: "Education",
        },
        {
          icon: "🛒",
          name: "E-commerce",
        },
        {
          icon: "🚚",
          name: "Logistics",
        },
        {
          icon: "🏭",
          name: "Manufacturing",
        },
        {
          icon: "🚗",
          name: "Automotive",
        },
        {
          icon: "🤖",
          name: "AI/ML",
        },
        {
          icon: "🏠",
          name: "Real Estate",
        },
        {
          icon: "📊",
          name: "Research Agencies",
        },
      ],
    };

    // Case Studies content object
    const caseStudiesContent = {
      sectionLabel: "Case Studies",
      caseStudies: [
        {
          title: "Cross-Platform Mobile App for Fitness & Wellness",
          description:
            "We created a comprehensive fitness tracking mobile application with social features, workout plans, and nutrition tracking. The app includes real-time health monitoring, community challenges, and personalized coaching recommendations for users worldwide.",
          image: caseStudyImage1,
          altText: "Agriculture Case Study",
          industry: "Mobile Development",
          technology: "React Native, Firebase",
          ctaText: "Read More",
          ctaLink: "/case-studies",
          stats: [
            {
              number: 2.5,
              label: "M Downloads",
            },
            {
              number: 4.8,
              label: "App Store Rating",
            },
          ],
        },
        {
          title: "E-Commerce Platform with Advanced Analytics",
          description:
            "Built a full-featured online marketplace with inventory management, payment processing, and customer analytics. The platform includes AI-powered product recommendations, multi-vendor support, and comprehensive reporting dashboard for business insights.",
          image: caseStudyImage2,
          altText: "Manufacturing Case Study",
          industry: "E-Commerce",
          technology: "Vue.js, Laravel, MySQL",
          ctaText: "Read More",
          ctaLink: "/case-studies",
          stats: [
            {
              number: 500,
              label: "K+ Products",
            },
            {
              number: 150,
              label: "% Revenue Growth",
            },
          ],
        },
        {
          title: "Multiplayer Gaming Platform with Real-Time Features",
          description:
            "Developed an immersive multiplayer gaming platform featuring real-time chat, leaderboards, tournament systems, and in-game purchases. The platform supports thousands of concurrent players with low-latency gameplay and advanced matchmaking algorithms.",
          image: caseStudyImage3,
          altText: "Fintech Case Study",
          industry: "Gaming",
          technology: "Unity, WebSocket, Redis",
          ctaText: "Read More",
          ctaLink: "/case-studies",
          stats: [
            {
              number: 100,
              label: "K+ Active Players",
            },
            {
              number: 15,
              label: "ms Latency",
            },
          ],
        },
      ],
    };

    // Why Sogdo content object
    const whySogdoContent = {
      sectionLabel: "Why Sogdo",
      mainTitle: "Why Choose",
      mainTitleHighlight: "Sogdo",
      description:
        "We combine cutting-edge technology with proven expertise to deliver solutions that scale with your business and drive innovation forward.",
      blocks: [
        {
          blockClass: "scalability-block",
          icon: "icon-06",
          title: "Champa Methodology",
          description:
            "Reduce service & development cost by 40% with our proven methodology that optimizes processes and maximizes efficiency.",
          features: [
            "40% Cost Reduction",
            "Optimized Processes",
            "Proven Methodology",
            "Maximum Efficiency",
          ],
          shape1: "/shapes/shape-01.png",
          shape2: "/shapes/shape-11.png",
        },
        {
          blockClass: "expertise-block",
          icon: "icon-07",
          title: "Full-cycle Product Teams",
          description:
            "Complete end-to-end development teams with expertise in every aspect of software product development and delivery.",
          features: [
            "End-to-end Development",
            "Cross-functional Teams",
            "Complete Product Lifecycle",
            "Integrated Solutions",
          ],
          shape1: "/shapes/shape-02.png",
          shape2: "/shapes/shape-12.png",
        },
        {
          blockClass: "innovation-block",
          icon: "icon-08",
          title: "Modern Tech Stack & Architecture",
          description:
            "Cutting-edge technology stack and modern architecture patterns that ensure scalability, performance, and future-proof solutions.",
          features: [
            "Latest Technologies",
            "Modern Architecture",
            "Scalable Solutions",
            "Future-proof Design",
          ],
          shape1: "/shapes/shape-04.png",
          shape2: "/shapes/shape-10.png",
        },
        {
          blockClass: "support-block",
          icon: "icon-09",
          title: "24x7 Support & Maintenance",
          description:
            "Round-the-clock support and maintenance services to ensure your systems run smoothly and efficiently at all times.",
          features: [
            "24/7 Monitoring",
            "Rapid Response",
            "Proactive Maintenance",
            "Continuous Support",
          ],
          shape1: "/shapes/shape-03.png",
          shape2: "/shapes/shape-09.png",
        },
        {
          blockClass: "speed-block",
          icon: "icon-10",
          title: "Fast Time to Market",
          description:
            "Accelerated development processes and agile methodologies that help you launch your products faster than ever before.",
          features: [
            "Agile Development",
            "Rapid Prototyping",
            "Quick Iterations",
            "Faster Launch",
          ],
          shape1: "/shapes/shape-05.png",
          shape2: "/shapes/shape-07.png",
        },
      ],
    };

    // Who We Are content object
    const whoWeAreContent = {
      sectionLabel: "Who We Are",
      mainTitle: "Enhancing Real-world Experiences with",
      mainTitleHighlight: "Technology",
      description:
        "Sogdo is a cutting-edge tech & product company specializing in innovative solutions. We combine advanced technology with creative design to deliver exceptional digital experiences that transform how people interact with the world around them.",
      ctaText: "Learn More",
      ctaLink: "/home-about",
      stats: {
        number: "10",
        suffix: "K+",
        label: "World wide Client",
      },
    };

    // Testimonials content object
    const testimonialsContent = {
      sectionTitle: "Clients & Case Studies",
      sectionDescription: "Real success stories and testimonials from our clients across various industries.",
      testimonials: [
        {
          id: 1,
          name: "How Sogdo's Cloud Plan Saved $100K/Year for Client",
          position: "Cloud Migration Success Story",
          image: require("@/assets/images/resource/team-01.png"),
          rating: 5,
          comment: "Our cloud migration strategy reduced infrastructure costs by 40% while improving performance and scalability."
        },
        {
          id: 2,
          name: "Migrated legacy fintech systems in 60 days",
          position: "Fintech Modernization Case Study",
          image: require("@/assets/images/resource/team-02.png"),
          rating: 5,
          comment: "Successfully modernized legacy banking systems with zero downtime and enhanced security features."
        },
        {
          id: 3,
          name: "AI-Powered Healthcare Platform Development",
          position: "Healthcare Technology Innovation",
          image: require("@/assets/images/resource/team-03.png"),
          rating: 5,
          comment: "Developed comprehensive healthcare platform with AI diagnostics and patient management systems."
        },
        {
          id: 4,
          name: "E-commerce Platform Scaling to 1M+ Users",
          position: "E-commerce Growth Success",
          image: require("@/assets/images/resource/team-04.png"),
          rating: 5,
          comment: "Scaled e-commerce platform to handle 1M+ concurrent users with 99.9% uptime and optimal performance."
        }
      ]
    };

    // Contact content object
    const contactContent = {
      sectionLabel: "Get In Touch",
      mainTitle: "Ready to Start Your",
      mainTitleHighlight: "Digital Journey",
      description:
        "Connect with our team of experts and let's discuss how we can help transform your ideas into reality with cutting-edge technology and innovative solutions.",
      contactMethods: [
        {
          icon: "icon-03",
          title: "Email Us",
          details: "info@sogdo.com",
          subtitle: "We'll respond within 24 hours",
        },
        {
          icon: "icon-04",
          title: "Call Us",
          details: "+1 (555) 123-4567",
          subtitle: "Mon-Fri, 9AM-6PM EST",
        },
        {
          icon: "icon-05",
          title: "Visit Us",
          details: "123 Tech Street<br>Innovation District",
          subtitle: "Available for meetings",
        },
      ],
    };

    return {
      shap1,
      bannerBg,
      banner1,
      c2,
      caseStudyImage1,
      caseStudyImage2,
      caseStudyImage3,
      aboutUsContent,
      ourOfferingsContent,
      industriesContent,
      caseStudiesContent,
      whySogdoContent,
      whoWeAreContent,
      testimonialsContent,
      contactContent,
    };
  },
};
</script>

<style scoped>
/* Import Google Fonts - Exact same as React project */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Import Flaticon - Same as React project */
@import "@/assets/scss/Flaticon.scss";
@import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

/* Keyframe Animations - Exact same as React project */
@keyframes anim {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes heroShapeFour {
  0%,
  100% {
    border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;
    transform: translate3d(0, 0, 0) rotateZ(0.02deg);
  }
  35% {
    border-radius: 70% 30% 46% 54% / 30% 29% 71% 70%;
    transform: translate3d(0, 10px, 0) rotateZ(0.02deg);
  }
  50% {
    transform: translate3d(0, 0, 0) rotateZ(0.02deg);
  }
  65% {
    border-radius: 100% 60% 60% 100% / 100% 100% 60% 60%;
    transform: translate3d(0, 20px, 0) rotateZ(0.03deg);
  }
}

/* Global Body Styles - Exact same as React project */
body {
  font-size: 16px;
  color: #fff;
  line-height: 28px;
  font-weight: 400;
  background: #00061a;
  font-family: "Archivo", sans-serif;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  -webkit-font-smoothing: antialiased;
}

/* Header Container - Same as Vue.js header */
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Banner Section Styles - Exact same as React project */
.banner__one {
  position: relative;
  overflow: hidden;
  background: #00061a;
}

.banner__one .banner__bg {
  left: 0;
  top: -14px;
  width: 100%;
  height: 100%;
  position: absolute;
  background-repeat: no-repeat;
  will-change: border-radius, transform, opacity;
  animation: heroShapeFour 3s linear infinite;
  z-index: -1;
}

.banner__data {
  position: relative;
  z-index: 2;
  padding: 50px 0px 100px;
}

.banner__data:before {
  content: "";
  border-radius: 679.189px;
  background: linear-gradient(
    192deg,
    rgba(246, 236, 79, 0.32) 0%,
    rgba(150, 6, 147, 0.6) 100%
  );
  filter: blur(150px);
  width: 460.256px;
  height: 679.189px;
  transform: rotate(21.269deg);
  flex-shrink: 0;
  position: absolute;
  z-index: -1;
  left: 40%;
}
@media (max-width: 991px) {
  .banner__data:before {
    left: 0%;
    width: 260.256px;
    height: 479.189px;
  }
}

.banner__left {
  padding-top: 26px;
  margin-bottom: 40px;
}

.banner__title h1 {
  color: #fff;
  font-family: "Archivo", sans-serif;
  font-size: 80px;
  font-style: normal;
  font-weight: 700;
  line-height: 90px;
  margin-bottom: 20px;
}

.sub__title h4 {
  color: #f6ec4f;
  font-family: "Archivo", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 13.2px;
  text-transform: uppercase;
  margin-bottom: 15px;
}

.text p {
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 30px;
}
@media (max-width: 991px) {
  .text p {
    margin-bottom: 0px;
  }
}

.theme-btn {
  display: inline-flex;
  align-items: center;
  padding: 15px 30px;
  background: #f6ec4f;
  color: #00061a;
  text-decoration: none;
  border-radius: 5px;
  font-family: "Archivo", sans-serif;
  font-weight: 600;
  transition: all 0.3s ease;
  margin: 20px 0;
}

.theme-btn i {
  margin-right: 10px;
  font-size: 16px;
  transition: transform 0.3s ease;
}

.theme-btn:hover i {
  transform: translateX(3px);
}

.theme-btn:hover {
  background: #e5d43f;
  color: #00061a;
  transform: translateY(-2px);
}

.banner__right {
  text-align: center;
}

.image__one img {
  width: 100%;
  max-width: 100%;
  height: auto;
}

.circle-main {
  text-align: center;
  height: 230px;
  width: 230px;
  display: block;
  background: #f6ec4f;
  border-radius: 50%;
  position: relative;
}

.circle-main:before {
  content: "";
  position: absolute;
  height: 210px;
  width: 210px;
  border-radius: 50%;
  border: 1px dashed #00061a;
  top: 10px;
  right: 10px;
}

.circle {
  position: relative;
  width: 100%;
  height: 100%;
}

.circle h1 {
  font-size: 100px;
  font-weight: 600;
  line-height: 1.8em;
  padding-top: 20px;
  color: #00061a;
}

.circle img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.round-text {
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 50%;
}

.text_1 {
  width: 100%;
  height: 100%;
  position: absolute;
  animation: anim 20s linear infinite;
  top: 14px;
  right: -14px;
}

.text_1 span {
  position: absolute;
  left: 50%;
  transform-origin: 0 100px;
}

.text_2 {
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
  color: #00061a;
}

.icon__image__banner {
  position: absolute;
  left: -109px;
  bottom: -61px;
}
@media (max-width: 991px) {
  .icon__image__banner {
    left: 50%;
    transform: translateX(-50%);
  }
}

/* Pattern Layer */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.banner__icon {
  background-repeat: no-repeat;
  right: 0;
  top: 22px;
  width: 370px;
  height: 469px;
}

/* Ensure banner section doesn't overflow */
section.banner__one {
  overflow: visible;
}

/* Custom button styling for home banner - More specific to avoid conflicts */
.home-page .banner__one .btn-box {
  display: flex !important;
  gap: 20px !important;
  flex-wrap: wrap !important;
}

.home-page .banner__one .btn-box .theme-btn {
  padding: 12px 30px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  border-radius: 0 !important;
  background: linear-gradient(219deg, #fb0e76 0%, #910694 100%) !important;
  color: #fff !important;
  text-decoration: none !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;
  transition: all 0.3s ease !important;
  border: 2px solid transparent !important;
}

.home-page .banner__one .btn-box .theme-btn.outline-btn {
  background: transparent !important;
  border: 2px solid #fb0e76 !important;
  color: #fb0e76 !important;
}

.home-page .banner__one .btn-box .theme-btn.outline-btn:hover {
  background: linear-gradient(219deg, #fb0e76 0%, #910694 100%) !important;
  color: #fff !important;
  border-color: transparent !important;
}

.home-page .banner__one .btn-box .theme-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 5px 15px rgba(251, 14, 118, 0.4) !important;
  color: #fff !important;
  text-decoration: none !important;
}

.home-page .banner__one .btn-box .theme-btn i {
  font-size: 12px !important;
  transition: transform 0.3s ease !important;
}

.home-page .banner__one .btn-box .theme-btn:hover i {
  transform: translateX(3px) !important;
}

/* Reduce banner height - More specific to avoid conflicts */

.home-page .banner__one .banner__data {
  padding-bottom: 60px !important;
}

/* Responsive Design - Exact same as React project */
@media only screen and (max-width: 767px) {
  /* Banner responsive adjustments - More specific to avoid conflicts */

  .home-page .banner__one .banner__data {
    padding-bottom: 0px !important;
  }

  .home-page .banner__title h1 {
    font-size: 40px !important;
    line-height: 50px !important;
  }

  .sub__title h4 {
    font-size: 16px;
    letter-spacing: 5.2px;
  }

  .title h2 {
    font-size: 30px;
    font-weight: 700;
    line-height: 40px;
  }

  .boild__text {
    font-size: 120px;
  }
}

@media only screen and (max-width: 399px) {
  .banner__left {
    padding-top: 26px;
  }

  .banner__title h1 {
    font-size: 40px;
    line-height: 50px;
  }

  .title h2 {
    font-size: 24px;
    line-height: 30px;
  }

  .boild__text {
    font-size: 80px;
  }
}
</style>